var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M21,3h-2v5H5V3H3C2.447,3,2,3.447,2,4v19c0,0.553,0.447,1,1,1h18c0.553,0,1-0.447,1-1V4 C22,3.447,21.553,3,21,3z M18,19H6v-2h12V19z M18,14H6v-2h12V14z"}}),_c('path',{attrs:{"d":"M14,2c0-1.105-0.895-2-2-2s-2,0.895-2,2H7v4h10V2H14z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }